import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { PermissionService } from '../services/permission/permission.service';

@Directive({
  selector: '[appHasAccess]'
})
export class HasAccessDirective implements OnInit, OnDestroy {
  @Input() appHasAccess!: string;
  @Input() accessLevel: number = 103;

  private subscription!: Subscription;
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService
  ) {}

  ngOnInit() {
    this.subscription = this.permissionService.isPermissionLoading$.subscribe(loading => {
      if (!loading && this.appHasAccess) {
        const hasAccess = this.permissionService.hasAccess(this.appHasAccess, this.accessLevel);
        
        if (hasAccess && !this.hasView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
        } else if (!hasAccess && this.hasView) {
          this.viewContainer.clear();
          this.hasView = false;
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
